/**
 * Created by kz on 28.06.17.
 */
import * as actions from './actions'
import * as getters from './getters'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    participations: [],
    current: {
      tender: {},
      participant: {},
      stage: {
        type: 'questionnaire',
        questionnaire: {
          groups: []
        }
      }
    }
  },
  actions,
  getters,
  mutations: {
    receive (state, participations) {
      state.participations = participations
    },
    current (state, participation) {
      _.assignIn(state.current, participation)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/participation/index.js